module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEVHcEwiIiIhISEhISEjIyMiIiIiIiIAAAAgICAiIiIiIiIhISEAAAAhISEhISG4338iAAAADnRSTlMApP0XFvu2AkdbjegE6cVZglgAAADySURBVEjHY2AYBaOANMDe5YAqwLKiAEPRya3CqAKG0XMwDJr7Ts0AWYA56d1NdKM49r17JIIs4Kj37nUDmiKuuHfvApGMYhZ99+7pAjRFLELv3j1KRvDN9N69U3RAdxSqKLoeZPPhHjREsx3JpXAPAr2G5g8GTAlkDWihB7cC1WocHsTuNVQP4vAaqgdxeQ3ZvTi9huxB3F5D8iBuryF5EI/XEB7E4zWEB/F5DeFBPF4jXhFR1hHjcKKCgJjAJCpaiIlgopIKMYmOqORLTEYgKksRkzmJyubEFBhEFT1EFWJEFYdEFaxEFdHEFfajYBTgBwD/uNnzwzbmSwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app/ic_navbar_close@3x.png
// module id = 234
// module chunks = 4